
import http from '../Http';
import { ThemeContext } from '../Http';
import { useContext, useState, useRef, useEffect } from 'react';
import utils from '../utils';
import { Modal, Button, Input, Form, Select, Switch, Space } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import InputPrefix from '../utils/InputPrefix';
import { useTranslation } from 'react-i18next';

function DeviceModify(props) {
    const setTip = useContext(utils.tipContext);
    const { t } = useTranslation();

    const session = useContext(ThemeContext);
    const isDistributor = session && session["IsDistributorUser"] == 1;


    const { show, onClose, row } = props;

    const [form] = Form.useForm();

    const [productSelectOptions, setProductSelectOptions] = useState([]); 
    const [distributorSelectOptions, setDistributorSelectOptions] = useState([]);
    const [inverterManufacturerSelectOptions, setInverterManufacturerSelectOptions] = useState([]);
    const [productCategory, setProductCategory] = useState(row.Category);
    const [timezoneSelectOptions, setTimezoneSelectOptions] = useState([]);
    const [inverterManufacturer, setInverterManufacturer] = useState(null)
    const [modelOptions, setModelOptions] = useState([]);

    const refTimerProductSearcher = useRef(null);
    const refProductSearchValue = useRef(null);
    const refTimerDistributorSearcher = useRef(null);
    const refDistributorSearchValue = useRef(null);
    const refTimerInverterManufacturerSearcher = useRef(null);
    const refInverterManufacturerSearchValue = useRef(null);
    const refTimerTimezoneSearcher = useRef(null);
    const refTimezoneSearchValue = useRef(null);

    useEffect(() => {
        if(inverterManufacturer !== 'Uhome') {
            setModelOptions([])
            return;
        }

        let active = true;

        (async () => {
            let resp = await http.post("integrated-inverter/uhome-model/list", {}).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                return null;
            });

            if (!active) {
                return;
            }

            if (resp === null || resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load_data_error") });
                setModelOptions([])
                return;
            }

            const ls = resp.data.map(({ Name, ID }) => {
                return (
                    <Select.Option key={ID} value={Name}>{Name}</Select.Option>
                );
            });
            setModelOptions(ls);
        })();

        return () => {
            active = false;
            console.log("DeviceManagement Effect Cancel");
        };
    }, [inverterManufacturer]);

    const handleCancle = () => {
        onClose(null);
    }

    const handleSubmit = async () => {
        const ps = await form.validateFields().catch(() => { return null });

        if (ps === null) {
            return;
        }

        ps["ID"] = row.ID;
        ps["CreateTime"] = row.CreateTime;
        ps.Enabled = ps.Enabled ? 1 : 0;
        ps.DistributorName = ps.DistributorName || "";
        ps.Inverters = ps.Inverters && ps.Inverters.length > 0 ? ps.Inverters.map((v) => {
            return `${v.InverterManufacturer},${v.InverterModel},${v.InverterSN}`;
        }).join(";") : "";
        ps.Inverters = encodeURIComponent(ps.Inverters)

        const resp = await http.post("device/management/modify", ps).then(async (r) => {
            return await r.json();
        }).catch((e) => {
            console.log("[DeviceModify]", e);
            return null;
        });

        try {
            if (resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("modify_error") });
                return
            }

            setTip({ open: true, severity: 'success', msg: t("modify_success") });

            ps.ID = resp.data.ID;
            //ps.CreateTime = resp.data.CreateTime;
            ps.GmtOffset = resp.data.GmtOffset;
            onClose(ps);
        } catch (e) {
            console.log("[DeviceModify]", e);

            setTip({ open: true, severity: "error", msg: t("modify_error") });
        }
    }

    const handleSearchProduct = (v) => {
        if (refTimerProductSearcher.current != null) {
            clearTimeout(refTimerProductSearcher.current);
        }
        refProductSearchValue.current = v;

        refTimerProductSearcher.current = setTimeout(async () => {
            const resp = await http.post("product/name/list", {
                Value: v,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[DeviceModify]", e);
                return null;
            });

            if (refProductSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load_product_list_error") });
                    return;
                }

                const ls = resp.data.map(({ Name, ID, Category }) => {
                    return (
                        <Select.Option key={ID} value={Name} category={Category}>{Name}</Select.Option>
                    );
                });
                setProductSelectOptions(ls);
            } catch (e) {
                console.log("[DeviceModify]", e);

                setTip({ open: true, severity: "error", msg: t("load_product_list_error") });
            }
        }, 300);
    }

    const handleSearchDistributor = (v) => {
        if (refTimerDistributorSearcher.current != null) {
            clearTimeout(refTimerDistributorSearcher.current);
        }
        refDistributorSearchValue.current = v;

        refTimerDistributorSearcher.current = setTimeout(async () => {
            const resp = await http.post("distributor/name/list", {
                Value: v,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[DeviceModify]", e);
                return null;
            });

            if (refDistributorSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load_distributor_list_error") });
                    return;
                }

                const ls = resp.data.map(({ Name, ID }) => {
                    return (
                        <Select.Option key={ID} value={Name}>{Name}</Select.Option>
                    );
                });
                setDistributorSelectOptions(ls);
            } catch (e) {
                console.log("[DeviceModify]", e);

                setTip({ open: true, severity: "error", msg: t("load_distributor_list_error") });
            }
        }, 300);
    }

    const handleSearchInverterManufacturer = (v) => {
        if (refTimerInverterManufacturerSearcher.current != null) {
            clearTimeout(refTimerInverterManufacturerSearcher.current);
        }
        refInverterManufacturerSearchValue.current = v;

        refTimerInverterManufacturerSearcher.current = setTimeout(async () => {
            const resp = await http.post("inverter-manufacturer/name/list", {
                Value: v,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[DeviceModify]", e);
                return null;
            });

            if (refInverterManufacturerSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load_inverter_manufacturer_list_error") });
                    return;
                }

                const ls = resp.data.map(({ Name, ID }) => {
                    return (
                        <Select.Option key={ID} value={Name}>{Name}</Select.Option>
                    );
                });
                setInverterManufacturerSelectOptions(ls);
            } catch (e) {
                console.log("[DeviceModify]", e);

                setTip({ open: true, severity: "error", msg: t("load_inverter_manufacturer_list_error") });
            }
        }, 300);
    }

    const handleSearchTimezone = (v) => {
        if (refTimerTimezoneSearcher.current != null) {
            clearTimeout(refTimerTimezoneSearcher.current);
        }
        refTimezoneSearchValue.current = v;

        refTimerTimezoneSearcher.current = setTimeout(async () => {
            const resp = await http.post("timezone/list", {
                Timezone: v,
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[DeviceAdd]", e);
                return null;
            });

            if (refTimezoneSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load_timezone_list_error") });
                    return;
                }

                const ls = resp.data.map(({ ZoneName, GmtOffset }) => {
                    var n = parseInt(GmtOffset);
                    var tz = "UTC+";
                    if (n < 0) {
                        tz = "UTC-";
                        n = Math.abs(n);
                    }
                    tz += Math.floor(n / 3600).toString().padStart(2, "0") + ":" + Math.floor((n % 3600) / 60).toString().padStart(2, "0")
                    return (
                        <Select.Option key={ZoneName} value={ZoneName}>{ZoneName}({tz})</Select.Option>
                    );
                });
                setTimezoneSelectOptions(ls);
            } catch (e) {
                console.log("[SummaryDataExporter]", e);

                setTip({ open: true, severity: "error", msg: t("load_timezone_list_error") });
            }
        }, 300);
    }

    var oldInverters = [];
    const handleProductSelected = (value, option) => {
        setProductCategory(option.category);
        // if (option.category == 2) {
        //     form.setFieldsValue({
        //         "Inverters": [{
        //             "InverterManufacturer": "Aobo",
        //             "InverterModel": "Uhome 5KHB-120",
        //             "InverterSN": "",
        //         }]
        //     })
        // } else {
        //     form.setFieldsValue({
        //         "Inverters": oldInverters
        //     })
        // }
        form.setFieldsValue({
            "Inverters": oldInverters
        })
    }

    const params = { ...row };
    params.Enabled = params.Enabled === 1 || params.Enabled === "1" ? true : false;
    const arr = (params["Inverters"] || "").split(";");
    const is = [];
    arr.forEach((i) => {
        const arr2 = i.split(",");
        if (arr2.length !== 3) {
            return
        }

        is.push({
            InverterManufacturer: arr2[0],
            InverterModel: arr2[1],
            InverterSN: arr2[2],
        });
    });
    params.Inverters = is;
    if (is.length > 0) {
        oldInverters = JSON.parse(JSON.stringify(is));
    }

    return (<Modal
        title={t("Modify Device")}
        visible={show}
        cancelText={t("Cancel")}
        okText={t("Submit")}
        mask={true}
        maskClosable={false}
        width={600}
        onCancel={handleCancle}
        onOk={handleSubmit}
        footer={[
            <Button
                key="Clear"
                shape="round"
                onClick={() => {
                    form.resetFields();
                }}
            >{t("Clear")}</Button>,
            <Button key="Cancel" shape="round" onClick={handleCancle}>{t("Cancel")}</Button>,
            <Button key="Submit" shape="round" type="primary" onClick={handleSubmit}>{t("Submit")}</Button>
        ]}
    >
        <Form
            labelAlign="right"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 25 }}
            form={form}
            initialValues={params}
        >
            <Form.Item
                name="SN"
                label=""
                rules={[{ required: true }]}
            >
                <Input prefix={<InputPrefix label="SN" required />} placeholder={t("Enter Device SN")} style={{ borderRadius: '20px' }} disabled={isDistributor} />
            </Form.Item>
            <Input.Group compact>
                <Button><span style={{color: 'red', verticalAlign: 'middle'}}>*&nbsp;</span>{t("Product")}</Button>
                <Form.Item
                    name="ProductName"
                    label=""
                    rules={[{ required: true }]}
                    style={{width: 'calc(100% - 90px'}}
                >
                    <Select
                        disabled={isDistributor}
                        showSearch
                        placeholder={t("Enter Product Name")}
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={handleSearchProduct}
                        onSelect={handleProductSelected}
                    >{productSelectOptions}</Select>
                </Form.Item>
            </Input.Group>
            <Input.Group compact>
                <Button>{t("Distributor")}</Button>
                <Form.Item
                    name="DistributorName"
                    label=""
                    style={{width: 'calc(100% - 98px'}}
                >
                    <Select
                        disabled={isDistributor}
                        showSearch
                        placeholder={t("Enter Distributor Name")}
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={handleSearchDistributor}
                    >{distributorSelectOptions}</Select>
                </Form.Item>
            </Input.Group>
            <Input.Group compact>
                <Button><span style={{color: 'red', verticalAlign: 'middle'}}>*&nbsp;</span>{t("Timezone")}</Button>
                <Form.Item
                    name="Timezone"
                    label=""
                    rules={[{ required: true }]}
                    style={{width: 'calc(100% - 102px'}}
                >
                    <Select
                        showSearch
                        placeholder={t("Timezone")}
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={(value) => {
                            handleSearchTimezone(value);
                        }}
                    >{timezoneSelectOptions}</Select>
                </Form.Item>
            </Input.Group>
            
            <Form.Item label={t("Inverters")}>
                <Form.List name="Inverters" label={t("Inverters")}>
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map(({ key, name, fieldKey, ...restField }) => (
                                <Space key={key} style={{ display: 'flex', marginBottom: 2 }} align="baseline">
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'InverterManufacturer']}
                                        // fieldKey={[fieldKey, 'InverterManufacturer']}
                                        key={[key, 'InverterManufacturer']}
                                        rules={[{ required: true, message: t('Missing Inverter Manufacturer name') }]}
                                    >
                                        {productCategory == 2222
                                            ?
                                            <Input readOnly={true} />
                                            : <Select
                                                style={{ width: 150 }}
                                                showSearch
                                                placeholder={t("Inverter Manufacturer Name")}
                                                defaultActiveFirstOption={false}
                                                showArrow={false}
                                                filterOption={false}
                                                onSearch={handleSearchInverterManufacturer}
                                                onSelect={value => setInverterManufacturer(value)}
                                            >{inverterManufacturerSelectOptions}</Select>}
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'InverterModel']}
                                        // fieldKey={[fieldKey, 'InverterModel']}
                                        key={[key, 'InverterModel']}
                                        rules={[{ required: true, message: 'Missing Inverter Model' }]}
                                    >
                                        {productCategory == 2222
                                            ?
                                            <Input readOnly={true} style={{ width: 150 }} />
                                            : (modelOptions.length > 0 ? 
                                                <Select
                                                    showSearch
                                                    placeholder={t("Inverter Model")}
                                                    defaultActiveFirstOption={false}
                                                    showArrow={true}
                                                    style={{width: 150}}
                                                >{modelOptions}</Select> :
                                                <Input key={inverterManufacturer} placeholder={t("Inverter Model")} style={{width: 150}} />)
                                        }
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'InverterSN']}
                                        // fieldKey={[fieldKey, 'InverterSN']}
                                        key={[key, 'InverterSN']}
                                        rules={[{ required: true, message: t('Missing Inverter SN') }]}
                                    >
                                        <Input placeholder={t("Inverter SN")} />
                                    </Form.Item>
                                    <MinusCircleOutlined onClick={() => remove(name)} hidden={productCategory == 2222} />
                                </Space>
                            ))}
                            <Form.Item>
                                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />} style={{borderRadius: '20px'}}>
                                    {t("Add Inverter")}
                                </Button>
                            </Form.Item>
                        </>
                    )}
                </Form.List>
            </Form.Item>
            <Form.Item
                name="Enabled"
                label={t("Enabled")}
                valuePropName="checked"
                style={{marginTop: '-30px'}}
            >
                <Switch disabled={isDistributor} />
            </Form.Item>
        </Form>
    </Modal>)
}


export default DeviceModify;